import axios from "axios";
import { TOKEN_KEY } from "../config";

// const cookies = new Cookies();
const getToken = () => {
  return sessionStorage.getItem(TOKEN_KEY);
};

export const getCategoryList = async (key) => {
  let q = key.queryKey[1];
  // let token = cookies.get(TOKEN_KEY);
  // let res = await q({ method: "GET", url: `${API_ENDPOINT}categorylist`, headers: { Authorization: getToken() ? `Bearer ${getToken()}` : '', } })
  // let res = await axios({
  //   method: "GET",
  //   url: `${process.env.REACT_APP_API_ENDPOINT}categorylist`,
  //   headers: { Authorization: getToken() ? `Bearer ${getToken()}` : "" },
  // });
  
  // Updated to use the correct API endpoint with query parameters
  const paramsObj = q.paramsObject || {};
  let res = await axios({
    method: "GET",
    url: `${process.env.REACT_APP_API_ENDPOINT}get-category-list`,
    params: {
      page_number: paramsObj.pageNo,
      limit: paramsObj.limit,
      search_query: paramsObj.searchQuery
    },
    headers: { Authorization: getToken() ? `Bearer ${getToken()}` : "" },
  });
  return res;
};

// Comment out the status update function
/*
export const handleUpdateCategoryStatus = async (data) => {
  // let token = cookies.get(TOKEN_KEY);
  const { id, home } = data;
  let fd = new FormData();
  fd.append("id", id);
  fd.append("status", home);
  let res = await axios({
    method: "POST",
    data: fd,
    url: `${process.env.REACT_APP_API_ENDPOINT}categorystatus`,
    headers: { Authorization: getToken() ? `Bearer ${getToken()}` : "" },
  });
  return res;
};
*/

export const addCategory = async (data) => {
  // let token = cookies.get(TOKEN_KEY);
  let fd = new FormData();
  // for (var key in data) {
  //   if (Array.isArray(data[key]) || typeof data[key] === "object") {
  //     fd.append(key, JSON.stringify(data[key]));
  //   } else {
  //     fd.append(key, data[key]);
  //   }
  // }
  
  // Updated to use only the name field
  fd.append("name", data.name);
  
  let res = await axios({
    method: "POST",
    data: fd,
    url: `${process.env.REACT_APP_API_ENDPOINT}create-category`,
    headers: { Authorization: getToken() ? `Bearer ${getToken()}` : "" },
  });
  return res;
};

export const editCategory = async (data) => {
  // let token = cookies.get(TOKEN_KEY);
  let fd = new FormData();
  // for (var key in data) {
  //   fd.append(key, data[key]);
  // }
  
  // Updated to use only category_id and name
  fd.append("category_id", data.id || data.category_id);
  fd.append("name", data.name);
  
  let res = await axios({
    method: "POST",
    data: fd,
    url: `${process.env.REACT_APP_API_ENDPOINT}update-category`,
    headers: { Authorization: getToken() ? `Bearer ${getToken()}` : "" },
  });
  return res;
};

export const deleteCategory = async (id) => {
  // let token = cookies.get(TOKEN_KEY);
  let fd = new FormData();
  fd.append("category_id", id);
  let res = await axios({
    method: "POST",
    data: fd,
    url: `${process.env.REACT_APP_API_ENDPOINT}delete-category`,
    headers: { Authorization: getToken() ? `Bearer ${getToken()}` : "" },
  });
  return res;
};

// New function to get data of a single category
export const getCategoryData = async (id) => {
  let res = await axios({
    method: "GET",
    url: `${process.env.REACT_APP_API_ENDPOINT}get-category-data`,
    params: { category_id: id },
    headers: { Authorization: getToken() ? `Bearer ${getToken()}` : "" },
  });
  return res;
};
